// Tee Shot Shopify Theme Scripts
document.addEventListener('DOMContentLoaded', function() {
    // Mobile Menu Toggle
    const mobileToggle = document.getElementById('mobile-menu-toggle');
    const mobileMenu = document.getElementById('mobile-menu');
    
    if (mobileToggle && mobileMenu) {
        mobileToggle.addEventListener('click', function() {
            mobileMenu.classList.toggle('hidden');
            const icon = mobileToggle.querySelector('i');
            if (icon.classList.contains('fa-bars')) {
                icon.classList.replace('fa-bars', 'fa-times');
            } else {
                icon.classList.replace('fa-times', 'fa-bars');
            }
        });
    }

    // Header Color Shift on Scroll
    const header = document.querySelector('header');
    window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
            header.classList.add('shadow-2xl');
        } else {
            header.classList.remove('shadow-2xl');
        }
    });

    // Fade-in animations for product cards
    const observerOptions = {
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('opacity-100', 'translate-y-0');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    document.querySelectorAll('.product-card').forEach(card => {
        card.classList.add('opacity-0', 'translate-y-4', 'transition-all', 'duration-700');
        observer.observe(card);
    });

    // Product Variant Switcher
    const variantGroups = document.querySelectorAll('.variant-option-group');
    const productJsonEl = document.getElementById('product-variants-json');

    if (variantGroups.length > 0 && productJsonEl) {
        let variants = [];
        try {
            variants = JSON.parse(productJsonEl.textContent);
        } catch (e) {
            console.error('Error parsing product variants JSON:', e);
        }

        const defaultImageEl = document.getElementById('product-default-image');
        const defaultImage = defaultImageEl ? JSON.parse(defaultImageEl.textContent) : '';

        function updateVariant() {
            // Get selected options in index order
            const selectedOptions = [];
            variantGroups.forEach(group => {
                const checkedRadio = group.querySelector('input[type="radio"]:checked');
                if (checkedRadio) {
                    selectedOptions.push(checkedRadio.value);
                }
            });

            // Find matching variant
            const matchedVariant = variants.find(variant => {
                return variant.options.every((option, index) => option === selectedOptions[index]);
            });

            if (matchedVariant) {
                // Update hidden input ID
                const idInput = document.querySelector('input[name="id"]');
                if (idInput) {
                    idInput.value = matchedVariant.id;
                }

                // Update price
                const priceElement = document.querySelector('.product-price');
                if (priceElement) {
                    priceElement.textContent = matchedVariant.price;
                }

                // Update image with smooth fade transition
                const imageElement = document.getElementById('main-product-image');
                if (imageElement) {
                    const newSrc = matchedVariant.featured_image || defaultImage;
                    if (newSrc && imageElement.getAttribute('src') !== newSrc) {
                        // Ensure smooth transition style is present
                        if (!imageElement.style.transition.includes('opacity')) {
                            imageElement.style.transition = 'opacity 250ms ease-in-out';
                        }
                        
                        // Set loading state (opacity fade out)
                        imageElement.setAttribute('data-loading-src', newSrc);
                        imageElement.style.opacity = '0';
                        
                        // Preload the image in the background to prevent flashing
                        const tempImg = new Image();
                        tempImg.onload = function() {
                            // Check if this matches the latest selection to prevent race conditions
                            if (imageElement.getAttribute('data-loading-src') === newSrc) {
                                imageElement.src = newSrc;
                                imageElement.style.opacity = '1';
                            }
                        };
                        tempImg.src = newSrc;
                    }
                }

                // Update button state and text
                const submitBtn = document.querySelector('button[name="add"]');
                if (submitBtn) {
                    if (matchedVariant.available) {
                        submitBtn.disabled = false;
                        submitBtn.textContent = 'Add to Basket';
                    } else {
                        submitBtn.disabled = true;
                        submitBtn.textContent = 'Out of Stock';
                    }
                }

                // Update URL
                const url = new URL(window.location.href);
                url.searchParams.set('variant', matchedVariant.id);
                window.history.replaceState({ path: url.href }, '', url.href);
            }
        }

        // Listen for changes
        variantGroups.forEach(group => {
            group.querySelectorAll('input[type="radio"]').forEach(radio => {
                radio.addEventListener('change', updateVariant);
            });
        });

        // Run once on load to sync initial state
        updateVariant();
    }

    // Size Guide Modal logic
    const sizeGuideTrigger = document.getElementById('size-guide-trigger');
    const sizeGuideModal = document.getElementById('size-guide-modal');
    const closeSizeGuide = document.getElementById('close-size-guide');

    if (sizeGuideTrigger && sizeGuideModal) {
        sizeGuideTrigger.addEventListener('click', function() {
            sizeGuideModal.classList.remove('hidden');
            sizeGuideModal.classList.add('flex');
        });
    }

    if (closeSizeGuide && sizeGuideModal) {
        closeSizeGuide.addEventListener('click', function() {
            sizeGuideModal.classList.remove('flex');
            sizeGuideModal.classList.add('hidden');
        });

        // Close on clicking outside the modal box
        sizeGuideModal.addEventListener('click', function(e) {
            if (e.target === sizeGuideModal) {
                sizeGuideModal.classList.remove('flex');
                sizeGuideModal.classList.add('hidden');
            }
        });
    }

    // Collection Category Tab Filtering
    const tabsContainer = document.getElementById('collection-tabs');
    if (tabsContainer) {
        const tabs = tabsContainer.querySelectorAll('button[data-tab]');
        const validCategories = ['mens', 'womens', 'unisex', 'hats', 'accessories'];
        
        const sections = {
            mens: document.getElementById('mens'),
            womens: document.getElementById('womens'),
            unisex: document.getElementById('unisex'),
            hats: document.getElementById('hats'),
            accessories: document.getElementById('accessories')
        };

        function getHashCategory() {
            const hash = window.location.hash.replace('#', '');
            if (validCategories.includes(hash)) {
                return hash;
            }
            const collectionHandle = tabsContainer.getAttribute('data-collection-handle');
            const activeHandle = collectionHandle === 'headwear' ? 'hats' : collectionHandle;
            return validCategories.includes(activeHandle) ? activeHandle : 'all';
        }

        function updateCatalogFilter() {
            const activeTab = getHashCategory();

            // 1. Update tab button active states
            tabs.forEach(tab => {
                const tabId = tab.getAttribute('data-tab');
                if (tabId === activeTab) {
                    tab.className = 'px-6 py-3 rounded-full text-[10px] font-black uppercase tracking-widest transition-all duration-300 border bg-gold text-primary border-gold shadow-[0_0_20px_rgba(214,190,152,0.3)]';
                } else {
                    tab.className = 'px-6 py-3 rounded-full text-[10px] font-black uppercase tracking-widest transition-all duration-300 border bg-white/5 border-white/10 text-white/70 hover:border-gold/50 hover:text-white';
                }
            });

            // 2. Filter section visibility
            Object.keys(sections).forEach(key => {
                const section = sections[key];
                if (section) {
                    if (activeTab === 'all' || activeTab === key) {
                        section.classList.remove('hidden');
                    } else {
                        section.classList.add('hidden');
                    }
                }
            });
        }

        // Add click events to tab buttons to update the hash
        tabs.forEach(tab => {
            tab.addEventListener('click', function() {
                const tabId = tab.getAttribute('data-tab');
                if (tabId === 'all') {
                    history.pushState(null, null, ' ');
                    updateCatalogFilter();
                } else {
                    window.location.hash = tabId;
                }
            });
        });

        // Listen for hash changes
        window.addEventListener('hashchange', updateCatalogFilter);

        // Run once on load to filter initial state
        updateCatalogFilter();
    }
});

